export default __webpack_public_path__ + "images/logos/logo-basic.png?e575bdfe1995413508a8c97b5839789476d251bd6d5cf87d1064ddea002c43f2";